function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,5.75h-69A4.54,4.54,0,0,0,7,10.35V41.4a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1V79.84a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V55.55A3.4,3.4,0,0,0,12,52.71a3.28,3.28,0,1,0-6.55,0A3.37,3.37,0,0,0,7,55.55V79.84a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.35A4.54,4.54,0,0,0,80.4,5.75Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.89,32l-13.24-5.5a1.59,1.59,0,0,0-1,0L32.28,32a1.22,1.22,0,0,0-.78,1.24v6.73A22.86,22.86,0,0,0,45.64,61a1.59,1.59,0,0,0,1,0,22.74,22.74,0,0,0,14.14-21.1V33.19A1.33,1.33,0,0,0,59.89,32Zm-1.91,8A20.17,20.17,0,0,1,46,58.33,20,20,0,0,1,34,40V34.2l12-4.94L58,34.2Zm-13.47,4.6,5.84-5.83a1.35,1.35,0,1,1,1.91,1.91h0l-6.85,6.84a1.3,1.3,0,0,1-1.91,0l-3.81-3.81a1.3,1.3,0,0,1,0-1.91h0a1.3,1.3,0,0,1,1.91,0Z",
    style: {
      fill: "#0075c9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericIcon);
export default __webpack_public_path__ + "static/media/genericIcon.95940a68.svg";
export { ForwardRef as ReactComponent };